import orderBy from 'lodash/orderBy'
import { IFacilityReviewStatuses, IShipperFacility, Maybe } from 'types/graphqlTypes'
import { getTimeAgoShort } from 'utils/formatDatetime'
import { IEdiMatchingFacilityFragment } from './graphql/EdiMatchingFacilityFragment'

interface IGetLastRanMessageProp
  extends Pick<IShipperFacility, 'totalShipmentsLastYear' | 'latestShipmentDelivery'> {}

export const getLastRanMessage = (shipperApplication: Maybe<IGetLastRanMessageProp>) => {
  const { latestShipmentDelivery, totalShipmentsLastYear = 0 } = shipperApplication || {}
  return totalShipmentsLastYear > 0 && latestShipmentDelivery
    ? `Ran ${totalShipmentsLastYear}x (past year) - Last ran ${getTimeAgoShort(
        latestShipmentDelivery
      )}`
    : 'Not ran within the past year'
}

const getLastShipmentDelivery = ({ shipperFacilities }: IEdiMatchingFacilityFragment) => {
  const [shipperFacility] = shipperFacilities || []
  const { latestShipmentDelivery, totalShipmentsLastYear } = shipperFacility || {}

  return totalShipmentsLastYear && latestShipmentDelivery ? new Date(latestShipmentDelivery) : null
}

const getPrimaryFacilities = ({ reviewStatus }: IEdiMatchingFacilityFragment) =>
  reviewStatus === IFacilityReviewStatuses.primary ? 1 : -1

export const getSortedFacilities = (ediMatchingFacilities: IEdiMatchingFacilityFragment[]) => {
  return orderBy(
    ediMatchingFacilities,
    [
      getPrimaryFacilities,
      'shipperFacilities.0.totalShipmentsLastYear',
      getLastShipmentDelivery,
      'location.address',
    ],
    ['desc', 'desc', 'desc', 'asc']
  )
}
